module.exports = __webpack_public_path__ + "img/twitter.62b1c14c.svg";